import { Observable } from 'rxjs';

export abstract class GoogleSheetSyncFacade {
  abstract isSyncing$: Observable<boolean>;
  abstract googleSheetSyncError$: Observable<string | null | undefined>;
  abstract datasetEditorSyncGoogleSheet(accountId: string, datasetId: string): void;
}
